






































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import baseSpinner from '@/components/Spinner';
import CustomImage from '@/components/Globals/CustomImage.vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

@Component({
  components: {
    CustomContainer,
    baseSpinner,
    CustomImage,
    Swiper,
    SwiperSlide
  }
})
export default class PatternMakerStickerTabs extends Vue {
  currentStickerGroup = "new";
  enableCarouselNavigation: boolean = true;
  enableSwiper = false;
  currentActiveIndex : Number = -1
  tabsSwiper = {
    slidesPerView: 3.25,
    slidesPerGroup: 1,
    loop: false,
    loopedSlides: 0,
    speed: 300,
    breakpoints: {
      768: {
        slidesPerView: 5,
      },
      1024: {
        slidesPerView: 7,
      },
    },
    shortSwipes: false,
    navigation: {
      prevEl: '.patternmaker-sticker-tabs-content-nav-button-previous',
      nextEl: '.patternmaker-sticker-tabs-content-nav-button-next',
    },
  }

  @Prop({default: () => []})
  tabs!: any[];

  @Watch('stickerGroupsArray')
  public watchStickerGroupsArray (){
    this.checkEnableCarouselNavigation();
  }

  get locale() {
    return this.$store.state.utils.configuration.locale;
  }

  get stickerGroups() {
    return this.$store.state.utils.availableStickersByGroup;
  }

  get currentAvailableStickersIds() {
    return (this as any).currentAvailableStickers.map((sticker: any) => sticker.id);
  }

  get stickerGroupsArray() {
    return this.$props.tabs.map((tab: any) => ({
      ...tab,
      display_name: tab.display_name.hasOwnProperty(this.locale) ? tab.display_name[this.locale] : tab.display_name.default
    }));
  }

  checkEnableCarouselNavigation() {
    let enableLoop;
    const viewportWidth = window.innerWidth;
    const breakpoints = this.tabsSwiper.breakpoints ? Object.keys(this.tabsSwiper.breakpoints).sort((a, b) => Number(a)-Number(b)) : [];
    if (!breakpoints.length || viewportWidth < Number(breakpoints[0])) {
      enableLoop = this.stickerGroupsArray.length > this.tabsSwiper.slidesPerView;
    }
    for (let i = 0; i < breakpoints.length - 1 && !enableLoop; i++) {
      if (viewportWidth >= Number(breakpoints[i]) && viewportWidth < Number(breakpoints[i + 1])) {
        enableLoop = this.stickerGroupsArray.length > (this as any).tabsSwiper.breakpoints[breakpoints[i]].slidesPerView;
      }
    }
    if (!enableLoop && breakpoints.length && viewportWidth >= Number(breakpoints[breakpoints.length - 1])) {
      enableLoop = this.stickerGroupsArray.length > (this as any).tabsSwiper.breakpoints[breakpoints[breakpoints.length - 1]].slidesPerView;
    }
    (this as any).tabsSwiper.loop = enableLoop;
    if (enableLoop && this.stickerGroupsArray) this.tabsSwiper.loopedSlides = this.stickerGroupsArray.length;
    (this as any).enableCarouselNavigation = enableLoop && window.innerWidth >= 768;
    this.enableSwiper = !!this.stickerGroupsArray.length;
  }

  onTabClicked(event: any) {
    const groupName = event.target.getAttribute('data-group-name');

    if (groupName) {
      this.updateSelectedTab(groupName);
      this.$eventBus.$emit('patternmaker-go-to-sticker', { groupName, moveToFirstStickerOfGroup: true });
      if (this.$store.getters['utils/useEcomDataLayerFormat']) {
        (this as any).$patternMakerDatalayer.logAnalyticsEvent({
          action: 'Select Overlay Category',
          eventLabel: groupName,
          capitalized: true
        });
      }
    }
  }

  updateSelectedTab(groupName: '') {
    if (!groupName) return;
    const tab = this.stickerGroupsArray.find((group: any) => group.name === groupName);
    const originalArrayIndex = this.stickerGroupsArray.indexOf(tab);

    const previousStickerGroup = this.currentStickerGroup;
    const previousActiveIndex = this.currentActiveIndex;
    const activeIndex = (this as any).$refs.tabsCarousel.$swiper.activeIndex;
    this.currentStickerGroup = groupName;

    if (this.tabsSwiper.loop && (previousStickerGroup !== this.currentStickerGroup || previousActiveIndex !== activeIndex)) {
      const totalOriginalElements = this.stickerGroupsArray.length;
      const totalLoopedSlides = (this as any).$refs.tabsCarousel.$swiper.loopedSlides || 0;
      let lowerPosition = originalArrayIndex + totalLoopedSlides - totalOriginalElements;
      let upperPosition = originalArrayIndex + totalLoopedSlides;
      if (lowerPosition < 0) { // advance to next 'window'
        lowerPosition += totalOriginalElements;
        upperPosition += totalOriginalElements;
      }
      const distanceToLowerPosition = Math.abs(activeIndex - lowerPosition);
      const distanceToUpperPosition = Math.abs(activeIndex - upperPosition);
      let position;
      // finds the closest position
      if (distanceToLowerPosition < distanceToUpperPosition && lowerPosition >= 0) {
        position = lowerPosition;
      } else {
        position = upperPosition;
      }
      // first try to use prev/next to avoid the jump caused by a sequence of calls to slideTo
      if (position === activeIndex - 1) {
        (this as any).$refs.tabsCarousel.$swiper.slidePrev();
      } else if (position === activeIndex + 1) {
        (this as any).$refs.tabsCarousel.$swiper.slideNext();
      } else {
        const slidedWithSuccess = (this as any).$refs.tabsCarousel.$swiper.slideTo(position, this.tabsSwiper.speed, false);
        if (!slidedWithSuccess && position !== activeIndex) { // go back one 'window'
          position -= totalOriginalElements;
          (this as any).$refs.tabsCarousel.$swiper.slideTo(position, this.tabsSwiper.speed, false);
        }
      }
      this.currentActiveIndex = position;
    }
  }

  created() {
    this.$eventBus.$on('sticker-tab-selected', this.updateSelectedTab);
    window.addEventListener('resize', this.checkEnableCarouselNavigation);
  }

  mounted() {
    this.checkEnableCarouselNavigation();
  }

  beforeDestroy() {
    this.$eventBus.$off('sticker-tab-selected', this.updateSelectedTab);
    window.removeEventListener('resize', this.checkEnableCarouselNavigation);
  }

}
